import { getFunctions, httpsCallable, connectFunctionsEmulator } from 'firebase/functions';
import { app } from '../lib/firebase';

const functions = getFunctions(app);

// Ha development módban vagyunk, csatlakozzunk az emulátorhoz
// FONTOS: Ez csak egyszer fut le, amikor a modul először betöltődik
let emulatorConnected = false;
if ((process.env.NODE_ENV === 'development' || window.location.hostname === 'localhost') && !emulatorConnected) {
  try {
    connectFunctionsEmulator(functions, 'localhost', 5001);
    emulatorConnected = true;
    console.log('✅ Functions emulator csatlakoztatva: localhost:5001');
  } catch (error) {
    console.warn('⚠️ Functions emulator csatlakoztatás sikertelen:', error);
  }
}

export interface FoxpostLabelResponse {
  success: boolean;
  parcelId?: string;
  trackingNumber?: string;
  labelUrl?: string;
  error?: string;
}

/**
 * Foxpost címke generálás
 */
export const generateFoxpostLabel = async (orderId: string): Promise<FoxpostLabelResponse> => {
  try {
    console.log('📦 generateFoxpostLabel hívás:', { orderId, type: typeof orderId });
    const generateLabel = httpsCallable(functions, 'generateFoxpostLabel');
    const payload = { orderId };
    console.log('📤 Küldött payload:', payload);
    const result = await generateLabel(payload);
    console.log('📥 Kapott válasz:', result);
    
    return result.data as FoxpostLabelResponse;
  } catch (error: any) {
    console.error('❌ Foxpost címke generálási hiba:', error);
    console.error('Error details:', { message: error.message, code: error.code, details: error.details });
    return {
      success: false,
      error: error.message || 'Ismeretlen hiba történt'
    };
  }
};

/**
 * Foxpost címke törlése
 */
export const cancelFoxpostLabel = async (orderId: string, parcelId: string): Promise<{ success: boolean; error?: string }> => {
  try {
    const cancelLabel = httpsCallable(functions, 'cancelFoxpostLabel');
    const result = await cancelLabel({ orderId, parcelId });
    
    return result.data as { success: boolean };
  } catch (error: any) {
    console.error('Foxpost címke törlési hiba:', error);
    return {
      success: false,
      error: error.message || 'Ismeretlen hiba történt'
    };
  }
};
